
<template>
  <div >
    <b-card>
      <div class="row ml-1">
        <label class="font-weight-bold"> {{$t('dashboard.applyActivities.title')}}</label>
        <b-button
          @click="goTo(`${routes.flex.trainerApplyActivitiesList}`)"
          size="sm"
          variant="primary"
          class="ml-auto mr-3 esep-blue-bg text-light"
          v-b-tooltip.hover
          :title="$t('dashboard.applyActivities.show')"
        >
          <b-icon icon="arrow-right-circle-fill"></b-icon>
        </b-button>
      </div>
      <b-table
        id="trainings-table"
        perPage="5"
        striped
        hover
        borderless
        :items="applyActivitiesList"
        :fields="fields"
        responsive
        show-empty
        class="mt-2"
        thead-class="esep-blue-bg text-light"
      >

        <template v-slot:empty="">
          <h6>{{ $t("dashboard.applyActivities.emptyTable") }}</h6>
        </template>
      </b-table>
    </b-card>
    

  </div>
</template>

<script>
import EsepService from "../../services/esep.service";
import { routes } from "../../services/routing.service";
import {handleApiError} from "../../services/error.service";
import { prettifyDate} from '../../services/utils';

export default {

  mounted() {
    this.getPendingApplyActivities();
  },
  data() {
    return {
      applyActivitiesList: [],
      fields: [
        { key: "applyActivityId", label: "Αριθμός", sortable: true }, // needs to be translated
        { key: "moduleTitle", label: "Περιγραφή", sortable: true ,filterByFormatted: true, thClass: 'text-left', tdClass: 'text-left' },
        { key: "memberFullName", label: "Μέλος", sortable: true , thClass: 'text-left', tdClass: 'text-left'},
        { key: "dateAssigned", label: "Ημ/νια Ανάθεσης", sortable: true, formatter: 'prettifyDate'},
      ],
      routes: routes
    }
  },
  methods: {
    goTo(link) {
      location.replace(link);
    },
    getPendingApplyActivities() {
      EsepService.getApplyActivitiesByTrainer(this.$store.state.userInfo.orgMember.id).then(
        (response) => {
          this.$log.debug(response.data)
          this.applyActivitiesList = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    prettifyDate(date) {
      return prettifyDate(date);
    },
   
  }
}
</script>

<style>

</style>